import { DescriptionList, Text } from '@efast_public/fjd-component-library';
import React, { ReactNode } from 'react';

const areAllStringsIdentical = (strings: string[]): boolean => {
  if (strings.length === 0) return true;
  if (strings.length === 1) return true;

  const firstString = strings[0];
  return strings.every((str) => str === firstString);
};

interface DiffDescriptionListItemProps {
  title: ReactNode;
  values: string[];
  valueRenderer?: (value: string) => ReactNode;
  shouldSplitValue?: boolean;
  hasDivider?: boolean;
}

export function DiffDescriptionListItem({
  title,
  values,
  valueRenderer,
  hasDivider = true
}: DiffDescriptionListItemProps) {
  if (values.length === 0) return null;

  if (values.length === 1)
    return (
      <>
        {hasDivider && <hr className="fjd2-description-list_divider" />}
        <DescriptionList.Item
          title={title}
          description={valueRenderer?.(values[0]) ?? values[0]}
        />
      </>
    );

  if (areAllStringsIdentical(values)) return null;

  return (
    <>
      {hasDivider && <hr className="fjd2-description-list_divider" />}
      <DescriptionList.Item
        title={<div style={{ width: '15vw' }}>{title}</div>}
        description={
          <div style={{ display: 'flex', gap: '4px', flexDirection: 'row' }}>
            {values.map((value) => (
              <div key={value} style={{ flex: 1 }}>
                {valueRenderer?.(value) ?? value}
              </div>
            ))}
          </div>
        }
      />
    </>
  );
}
